import React from "react";

export default class NoCommentsDarkSVG extends React.Component {
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 155 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.62427 6.80603L4.56018 7.74194"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.59204 8.78088L6.52796 9.7168"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.52771 6.80603L5.5918 7.74194"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.55969 8.78101L3.62378 9.71692"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M113.107 78.8854L114.043 79.8213"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M115.082 80.8604L116.018 81.7963"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M116.018 78.8854L115.082 79.8213"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.043 80.8604L113.107 81.7963"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.81 11.8153L135.753 12.7512"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.785 13.7905L137.721 14.7264"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M137.722 11.8159L136.786 12.7518"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M135.753 13.7905L134.81 14.7264"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.325 107.665L44.2609 108.601"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.2991 109.64L46.235 110.576"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.2347 107.665L45.2988 108.601"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.2609 109.64L43.325 110.576"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.7686 0.219849V17.0319"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.7681 88.4217V105.234"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M64.7681 34.8691V35.2132" stroke="#475569" strokeWidth="0.344086" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M64.7678 36.5758V72.753"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="0.68 0.68"
        />
        <path d="M64.7681 73.4339V73.778" stroke="#475569" strokeWidth="0.344086" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M117.599 34.8693H11.9444C9.91431 34.8693 8.2627 33.2246 8.2627 31.1876V15.4973C8.2627 13.4672 9.90743 11.8156 11.9444 11.8156H117.599C119.63 11.8156 121.281 13.4603 121.281 15.4973V31.1876C121.274 33.2177 119.63 34.8693 117.599 34.8693Z"
          fill="#1F2937"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M89.9555 18.381H32.4175V22.0558H89.9555V18.381Z" fill="#475569" />
        <path d="M93.741 24.6293H32.418V28.3041H93.741V24.6293Z" fill="#475569" />
        <path
          d="M26.9672 14.4991H12.9629C11.9444 14.4991 11.1255 15.325 11.1255 16.3366V30.3409C11.1255 31.3594 11.9513 32.1783 12.9629 32.1783H26.9672C27.9857 32.1783 28.8046 31.3525 28.8046 30.3409V16.3366C28.8115 15.325 27.9857 14.4991 26.9672 14.4991Z"
          fill="#475569"
        />
        <path
          d="M117.599 96.8253H11.9444C9.91431 96.8253 8.2627 95.1806 8.2627 93.1436V77.4533C8.2627 75.4232 9.90743 73.7715 11.9444 73.7715H117.599C119.63 73.7715 121.281 75.4163 121.281 77.4533V93.1436C121.274 95.1806 119.63 96.8253 117.599 96.8253Z"
          fill="#1F2937"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M89.9555 80.3369H32.4175V84.0118H89.9555V80.3369Z" fill="#475569" />
        <path d="M101.916 86.586H32.418V90.2608H101.916V86.586Z" fill="#475569" />
        <path
          d="M26.9675 76.462H12.9632C11.9447 76.462 11.1257 77.2878 11.1257 78.2995V92.3038C11.1257 93.3223 11.9515 94.1412 12.9632 94.1412H26.9675C27.9859 94.1412 28.8049 93.3154 28.8049 92.3038V78.2995C28.8118 77.281 27.9859 76.462 26.9675 76.462Z"
          fill="#475569"
        />
        <path
          d="M27.0428 95.8759C28.9735 95.8759 30.5387 94.3108 30.5387 92.38C30.5387 90.4493 28.9735 88.8841 27.0428 88.8841C25.112 88.8841 23.5469 90.4493 23.5469 92.38C23.5469 94.3108 25.112 95.8759 27.0428 95.8759Z"
          fill="#1F2937"
        />
        <path
          d="M27.0428 95.2901C28.6505 95.2901 29.9538 93.9869 29.9538 92.3792C29.9538 90.7715 28.6505 89.4682 27.0428 89.4682C25.4351 89.4682 24.1318 90.7715 24.1318 92.3792C24.1318 93.9869 25.4351 95.2901 27.0428 95.2901Z"
          fill="#475569"
        />
        <path
          d="M138.141 65.8442H32.4864C30.4563 65.8442 28.8047 64.1995 28.8047 62.1625V46.4722C28.8047 44.4421 30.4494 42.7905 32.4864 42.7905H138.141C140.172 42.7905 141.823 44.4352 141.823 46.4722V62.1625C141.816 64.1995 140.172 65.8442 138.141 65.8442Z"
          fill="#475569"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.721 53.0368H135.924"
          stroke="#1F2937"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.721 55.6104H135.924"
          stroke="#1F2937"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M121.274 49.3624H52.959V53.0372H121.274V49.3624Z" fill="#1F2937" />
        <path d="M113.848 55.611H52.959V59.2858H113.848V55.611Z" fill="#1F2937" />
        <path
          d="M47.5087 45.4807H33.5044C32.4859 45.4807 31.667 46.3065 31.667 47.3181V61.3224C31.667 62.3409 32.4928 63.1599 33.5044 63.1599H47.5087C48.5272 63.1599 49.3461 62.334 49.3461 61.3224V47.3181C49.353 46.3065 48.5272 45.4807 47.5087 45.4807Z"
          fill="#1F2937"
        />
        <path
          d="M47.5848 64.8943C49.5155 64.8943 51.0807 63.3291 51.0807 61.3984C51.0807 59.4676 49.5155 57.9025 47.5848 57.9025C45.654 57.9025 44.0889 59.4676 44.0889 61.3984C44.0889 63.3291 45.654 64.8943 47.5848 64.8943Z"
          fill="#475569"
        />
        <path
          d="M47.5846 64.3096C49.1922 64.3096 50.4955 63.0063 50.4955 61.3986C50.4955 59.791 49.1922 58.4877 47.5846 58.4877C45.9769 58.4877 44.6736 59.791 44.6736 61.3986C44.6736 63.0063 45.9769 64.3096 47.5846 64.3096Z"
          fill="#1F2937"
        />
        <path
          d="M144.547 40.2298L153.865 30.912"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.541 42.8311H150.755"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.946 40.2568V34.0426"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2956 59.347L12.9778 50.0292"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2952 61.9482H16.0879"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.897 59.3672V53.1599"
          stroke="#475569"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M111.613 21.684C112.04 23.0947 113.148 24.2027 114.558 24.6293C113.148 25.056 112.04 26.164 111.613 27.5747C111.186 26.164 110.078 25.056 108.668 24.6293C110.078 24.2027 111.186 23.0947 111.613 21.684Z"
          fill="#475569"
        />
        <path
          d="M2.93733 64.8937C3.24701 65.9191 4.05217 66.7243 5.07755 67.034C4.05217 67.3436 3.24701 68.1488 2.93733 69.1742C2.62766 68.1488 1.82249 67.3436 0.797119 67.034C1.82249 66.7243 2.62766 65.9191 2.93733 64.8937Z"
          fill="#475569"
        />{" "}
      </svg>
    );
  }
}
